


export function start(){ console.log('darkTheme>>>')
	const	body = document.querySelector('body')
	body.classList.toggle('darkTheme')

}